export default {
  sidePanelSubtitle: "First bach is out!",
  sidePanelTitle: "Hurray!",
  subtitle: "Output volume for first batch",
  tag: "Start of the day",
  title: "Production overview",
  ctaText: "Show my financial overview"
};
